import script from "./CloseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./CloseButton.vue?vue&type=script&setup=true&lang=js"

import "./CloseButton.vue?vue&type=style&index=0&id=270e6b92&lang=sass"

const __exports__ = script;

export default __exports__